import type { AuditStatus, InteractionStatus } from "@/types";

export const frameDurationSeconds = 2;
export const terminalStatuses: Array<InteractionStatus | AuditStatus> = ["completed", "failed", "cancelled"];

export const viewportDimensions = {
  desktop: { width: 1440, height: 1024 },
  mobile: { width: 390, height: 844 },
} as const;
